<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        送修作業
      </h1>
    </div>
    <div class="info_wrap col">
      <!-- 維修編號，申請人員，申請日期 -->
      <div class="fixed_info">
        <div>
          <p>
            維修編號 : {{ Form.RepairId }}
          </p>
        </div>
        <div>
          <p>
            申請人員 : {{ Form.ApplicantNickName }}
          </p>
        </div>
        <div>
          <p>
            申請日期 : {{ Form.ApplicationDate }}
          </p>
        </div>
      </div>
      <div class="content">
        <!-- 物品名稱 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              物品名稱：
            </div>
            <input type="text" class="form-control readonly_box" readonly v-model="Form.AssetName">
          </div>
        </div>
        <div class="row g-0">
          <!-- 資產編號 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                資產編號：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.AssetsId">
            </div>
          </div>
          <!-- 送修人員 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                送修人員：
              </div>
              <input type="text" class="form-control readonly_box" readonly v-model="Form.RepairPersonNickName">
            </div>
          </div>
        </div>
        <!-- 問題描述 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">問題描述：</div>
            <textarea style="height: 200px;" class="form-control readonly_box" readonly>{{ Form.Question }}</textarea>
          </div>
        </div>
        <!-- 報修照片 -->
        <div class="col-12 repair_photo_section">
          <div class="input-group mt-3">
            <div class="input-group-prepend">報修照片：</div>
          </div>
          <swiper-container class="swiper_section" :autoHeight="true" :space-between="40"
            :pagination="{ clickable: true, }" :modules="[Pagination]"
            :breakpoints="{ 0: { slidesPerView: 1, }, 768: { slidesPerView: 3, }, 1200: { slidesPerView: 3, }, }">
            <swiper-slide v-for="(item, index) in Form.existFile" :key="index">
              <img class="swiper_bottom_img" :src="item.FileLink">
              <button class='zoom_img' @click="utilsStore.viewFile(item)">
                <img src="@/assets/zoom.png">
              </button>
            </swiper-slide>
          </swiper-container>
          <div class="swiper_pagination"></div>
        </div>
      </div>
      <div class="fixed_info mt-5">
        <p>維修資訊</p>
      </div>
      <div class="content">
        <!-- 維修廠商 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">維修廠商 :</div>
            <input type="text" class="form-control" placeholder="最多輸入20字" maxlength="20" v-model="Form.RepairCompany">
          </div>
        </div>
        <!-- 外部維修單號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">外部維修單號 :</div>
            <input type="text" class="form-control" placeholder="最多輸入50字" maxlength="50"
              v-model="Form.ExternalRepairId">
          </div>
        </div>
        <div class="row g-0">
          <!-- 廠商聯絡人 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">廠商聯絡人 :</div>
              <input type="text" class="form-control" placeholder="最多輸入10字" maxlength="10" v-model="Form.ContactPerson">
            </div>
          </div>
          <!-- 聯絡電話 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">聯絡電話 :</div>
              <input type="text" class="form-control" placeholder="最多輸入20字" maxlength="20" v-model="Form.ContactPhone">
            </div>
          </div>
        </div>
        <div class="row g-0">
          <!-- 預計歸還日期 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">預計歸還日期 :</div>
              <input type="date" class="form-control" v-model="Form.ExpectedReturnDate">
            </div>
          </div>
          <!-- 送修日期 -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">送修日期 :</div>
              <input type="date" class="form-control" v-model="Form.RepairDate">
            </div>
          </div>
        </div>
        <!-- 備註 -->
        <div class="col-12">
          <div class="input-group d-flex">
            <div class="input-group-prepend">備註 :</div>
            <textarea style="height: 200px;" class="form-control" placeholder="最多輸入500字" maxlength="500"
              v-model="Form.Memo"></textarea>
          </div>
        </div>
        <!-- 文件上傳 -->
        <div class="col-12 repair_photo_section">
          <div class="input-group mt-3">
            <div class="input-group-prepend">文件上傳 :</div>
            <div class="mb-4 file_wrap">
              <button class="choose_btn" @click="fileInput.click();">選擇檔案</button>
              <input type="file" ref="fileInput" style="display: none;"
                @change="utilsStore.handleDocumentChange($event, { newDocument: Form.newDocument, viewDocument: Form.viewDocument, existDocument: Form.existRepairDocument })"
                multiple>
            </div>
          </div>
        </div>
        <div class="col selected_file">
          <div class="input-group">
            <div class="input-group-prepend mb-xl-3 mb-lg-3 mb-md-3">已選擇檔案 :</div>
            <div class='file_upload_box col'>
              <div v-for="(file, index) in Form.viewDocument" :key="index" class="file_upload_wrap">
                <p class='file_name'>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)">
                  <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                  @click="utilsStore.deleteDocumentFile('new', { newDocument: Form.newDocument, viewDocument: Form.viewDocument, existDocument: Form.existRepairDocument, deleteDocument: Form.deleteDocument }, index)">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 已上傳文件 -->
        <div class="col selected_file">
          <div class="input-group">
            <div class="input-group-prepend">已上傳文件 :</div>
            <div class="selected_file_wrap col">
              <div v-for="(file, index) in Form.existRepairDocument" :key="index" class="file_upload_wrap">
                <p>{{ file.FileName }}
                  <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                    @click="utilsStore.viewFile(file)">
                  <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                  @click="utilsStore.deleteDocumentFile('exist', { newDocument: Form.newDocument, viewDocument: Form.viewDocument, existDocument: Form.existRepairDocument, deleteDocument: Form.deleteDocument }, index)">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col button_wrap">
        <button class="back_btn" @click="utilsStore.goBack">回上一頁</button>
        <button class="send_btn" @click="submit">送出</button>
      </div>
    </div>
  </div>
  <view_modal></view_modal>
  <button type="button" id="openModal" data-bs-toggle="modal" data-bs-target="#viewFile_modal" class="d-none">modal
    button</button>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router'
import router from '@/router';
import view_modal from '@/components/view_modal.vue';
import Navbar from '@/components/Navbar.vue';
import axios from '@/axios/tokenInterceptor';
import { useRepairStore } from '@/store/repair/_index';
import { useUtilsStore } from '@/store';
import { storeToRefs } from 'pinia';
import { register } from 'swiper/element/bundle';
import { Pagination } from 'swiper/modules';
import { Repair_Process_Status } from '@/assets/js/enter_status';
const route = useRoute();
const RepairId = route.query.search_id;
const utilsStore = useUtilsStore();
const repairStore = useRepairStore();
const {
  Form,
} = storeToRefs(repairStore);
const fileInput = ref(null);

onMounted(() => {
  register();
  repairStore.$reset();
  repairStore.getDetails(RepairId, Repair_Process_Status, ['RepairDate', 'ExpectedReturnDate'])
});
/**
 * 送出
 */
async function submit() {
  try {
    // 先編輯表單上半部內容
    await sendUpperForm();
    // 再依照R_ID將 文件 單次檔案上傳
    const filePromises = [];
    for (let i = 0; i < Form.value.newDocument.length; i++) {
      filePromises.push(sendFileForm(RepairId, Form.value.newDocument[i], i));
    }
    // 等待所有檔案上傳完成
    await Promise.all(filePromises)
      .then(result => {
        const allSuccess = result.every(result => result === 'success')
        if (allSuccess) {
          alert('傳送維修資訊成功\n單號為:' + RepairId);
          router.push({
            name: 'Repair_Datagrid'
          });
        } else {
          alert('傳送維修資訊失敗')
        }
      })
  } catch (error) {
    console.error(error);
    alert(error)
  }
}
/**
 * 文字部分表單
 */
function sendUpperForm() {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    let requestData = {
      RepairId: Form.value.RepairId,
      RepairCompany: Form.value.RepairCompany,
      ExternalRepairId: Form.value.ExternalRepairId,
      ExpectedReturnDate: Form.value.ExpectedReturnDate,
      ContactPerson: Form.value.ContactPerson,
      ContactPhone: Form.value.ContactPhone,
      RepairDate: Form.value.RepairDate,
      Memo: Form.value.Memo,
      deleteDocument: Form.value.deleteDocument,
    };
    utilsStore.setFormData(requestData, form);
    axios.post('/RepairMng/SendingForRepair', form)
      .then(response => {
        const data = response.data;
        if (data.state === 'success') {
          const R_ID = data.resultList.R_ID;
          console.log('編輯上半部表單成功R_ID:', R_ID);
          resolve(R_ID);
        } else {
          reject(data.messages);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
/**
 * 上傳檔案
 * @param {String} RepairId 單號
 * @param {File} file File
 * @param {Number} index File index
 */
function sendFileForm(RepairId, file, index) {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('RepairId', RepairId);
    form.append('num', index);
    form.append('type', 'repair');
    form.append('Document', file);
    axios.post('/RepairMng/UploadDoc', form)
      .then((response) => {
        const data = response.data;
        if (data.state === 'success') {
          console.log(`第${index + 1}個檔案上傳成功`);
          resolve(data.state)
        } else {
          console.error(`第${index + 1}個檔案上傳失敗，` + response.data.messages);
          reject(`第${index + 1}個檔案上傳失敗，` + response.data.messages);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

span {
  @include red_star
}

.input-number {
  @include count_btn;
}

.readonly_box {
  @include readonly_box;
}

.form-check-input {
  align-self: center
}

.view_icon,
.trash_icon {
  cursor: pointer
}

.modal {
  .modal-body {
    padding: 20px;
    margin: auto;
  }

  .modal-content {
    margin: auto;
  }

  .modal-input-group-prepend {
    width: auto;
    font-weight: 700;
    font-size: 20px;
  }

  .modal-footer {
    padding: 0 12px 12px;
    border: none;
  }

  .modal-header {
    h5 {
      font-weight: 700;
    }

    background: #528091;
    color: white;
    display: flex;
    justify-content: center;

    .close_icon {
      cursor: pointer;
    }
  }
}

.custom-slide {
  display: flex;
  align-self: center;
}

.button_wrap {
  display: flex;
  justify-content: space-between;
  margin: 30px auto 5%;
  width: 210px;

  .back_btn {
    @include back_to_previous_btn;

    &:hover {
      background-color: #5d85bb;
    }
  }

  .send_btn {
    @include search_and_send_btn;

    &:hover {
      background-color: #5e7aa2;
    }
  }
}

.main_section {

  .info_wrap {
    .swiper_section {
      swiper-slide img {
        width: 100%;
        height: auto;
        padding: 40px 0;
      }
    }

    .fixed_info {
      @include fixed_info;

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .content {
      @include content_bg;

      .input-group {

        .readonly_box,
        .form-control {
          height: 35px;
          border-radius: 0;
        }

        .input-group-prepend {
          color: white;
          font-weight: 700;
          font-size: 20px;
        }
      }

      .selected_file {
        .file_upload_wrap {
          margin-bottom: 0;
          display: flex;

          img {
            width: 25px;
            height: 25px;
          }

          p {
            font-weight: 700;
            margin-bottom: 5px;
            color: white;
            word-break: break-word;

            &::before {
              margin-right: 10px;
              content: '·';
              font-weight: 700;
              color: white;
            }
          }
        }
      }

      .file_wrap {
        display: flex;
        flex-direction: column;

        .choose_btn {
          margin-bottom: 10px;
          @include choose_file_btn;

          &:hover {
            background: #3f608f;
          }
        }
      }
    }


  }
}

@media only screen and (min-width: 1200px) {
  .main_section {

    .swiper_section {
      swiper-slide img {
        padding: 40px 0;
      }
    }

    .info_wrap {
      margin: 8px auto 5%;
      width: 800px;

      .content {
        .input-group {
          flex-wrap: nowrap;



          .input-group-prepend {
            text-align: end;
            width: 155px;
          }
        }


      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {

    .swiper_section {
      swiper-slide img {
        padding: 40px 0;
      }
    }

    .info_wrap {
      margin: 8px auto 5%;
      padding: 0 5%;

      .content {
        .input-group {
          width: 100%;
          flex-wrap: nowrap;

          .input-number,
          .readonly_box {
            width: 100%;
          }

          .form-control {
            width: 54%;
          }

          .input-group-prepend {
            text-align: end;
            width: 145px;
          }
        }


      }

      .content:nth-child(4) {
        .input-group-prepend {
          width: 160px;
        }

        .input-group .form-control {
          width: 50%;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {

    .readonly_box,
    .form-control,
    .input-number {
      margin-left: unset !important;
    }

    .swiper_section {
      swiper-slide img {
        padding: 40px;
      }
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;

      }

      .content {
        .input-group {
          flex-direction: column;

          .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
            margin-left: unset;
            border-radius: 5px;
            margin-top: 5px;
            height: 35px;
          }

          .form-control {
            width: 100%;
          }

          .input-group-prepend {
            margin-bottom: 5px;
            width: 100px;
            white-space: nowrap;
          }
        }

        .selected_file {
          .input-group {
            flex-direction: column;
          }

        }

        .file_wrap {
          margin-left: unset !important;

          .choose_btn {
            margin-top: 5px;

          }
        }
      }
    }
  }
}
</style>